// extracted by mini-css-extract-plugin
export default {"exitBtn":"Button_exitBtn__wh9WD","modalWrapper":"Button_modalWrapper__97Zf+"};